import { Injectable } from '@angular/core';
import { BookingModel , VerifyBookingQrResponse,BookingDetailsResponse} from '../models/booking.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

 private readonly apiUrl = `${environment.apiUrl}/Proctoring`;

  constructor(
    private http: HttpClient
  ) {}

  verifyBookingQr(
  bookingId: number,
  dob: string,
  key: string
): Observable<VerifyBookingQrResponse> {

  console.log('[QR API] Sending bookingId:', bookingId);

  return this.http.post<VerifyBookingQrResponse>(
    `${this.apiUrl}/verify-qr`,
    {
      bookingId: bookingId,
      dob: dob,
      key: key
    }
  );
}

   getBookingDetails(
    bookingId: number
  ): Observable<BookingDetailsResponse> {

    return this.http.get<BookingDetailsResponse>(
      `${this.apiUrl}/${bookingId}/details`
    );
  }

  booking: BookingModel = {
    state: null,
    city: null,
    centreId: null,
    centreName: null,
    centreAddress: null,
    date: null,
    timeSlot: null,
    examScheduleSlotId: null,
    examScheduleId: null,
    fromTime: null,
    toTime: null
  };

  clearBooking(): void {
    this.booking = {
      state: null,
      city: null,
      centreId: null,
      centreName: null,
      centreAddress: null,
      date: null,
      timeSlot: null,
      examScheduleSlotId: null,
      examScheduleId: null,
      fromTime: null,
      toTime: null
    };
  }
}
